export const faqData = [
  {
    id: 1,
    question:
      "How reliable are the results from the Minemi Home Loan Eligibility Calculator?",
    answer:
      "The calculator provides a close estimate based on the information you enter. However, final approval is subject to the lender’s evaluation and verification process.",
  },
  {
    id: 2,
    question: "Will checking my home loan eligibility affect my credit score?",
    answer:
      "No, using the eligibility calculator does not impact your credit score since it performs only a soft inquiry.",
  },
  {
    id: 3,
    question:
      "Can I proceed with a home loan application after using the calculator?",
    answer:
      "Yes, if you meet the eligibility criteria, you can explore available loan options and begin the application process immediately.",
  },
  {
    id: 4,
    question: "What should I do if I don’t qualify for a home loan?",
    answer:
      "If you are not eligible, consider improving your financial profile by increasing your income, lowering existing debts, enhancing your credit score, or applying with a co-borrower to boost your chances.",
  },
];
